import React, { useState, useEffect, useRef } from 'react'
import axios from 'axios'
import { API_URL } from '../../Constant';
import { ToastContainer, toast } from 'react-toastify';
import messages from '../../assets/Messages.json'
import { Link, useNavigate } from 'react-router-dom';
import {showAppLoading,  generateYearRange, isNumeric, validateButtonASIBlock, getStatusFlagValue, isHqAsiAdminRole } from '../../Custom/Custom';
import asiTitle from '../../asi.json';

export default function BlockL({
   blockPageInfo,
   config,
   userInfoObject,
   blockInfo,
   accessAsiBlock,
   decode_token
}) {

   const [itemData, setItemData] = useState({});
   const [blockLData, setBlockLData] = useState({});
   const [blockCData, setBlockCData] = useState([]);
   const [balanceSheet, setBalanceSheet] = useState('');
   const [profitAndLossStatement, setProfitAndLossStatement] = useState('');
   const [attendanceMusterRoll, setAttendanceMusterRoll] = useState('');
   const [inspectionReport, setInspectionReport] = useState('');
   const [statusFlageval, setstatusFlageval] = useState('');
   const [others, setOthers] = useState('');
   const [rejectLog, setRejectLog] = useState([]);
   const [showRejectLogModal, setShowRejectLogModal] = useState(false);
   const [rejectLogError, setRejectLogError] = useState('');
   const [isRejectLogFetching, setIsRejectLogFetching] = useState(false);
   const bodyOverflowRef = useRef('');
   const statusUnitCode = localStorage.getItem('statusUnitCode');
   const statusUnitCodeTrim = String(statusUnitCode ?? '').trim();
   /** Block A — code 1: Balance Sheet mandatory; codes 4,5,7,8: Inspection Report mandatory */
   const isBlockAStatusUnitCodeOne = statusUnitCodeTrim === '1';
   const isBlockAInspectionReportMandatory = ['4', '5', '7', '8'].includes(statusUnitCodeTrim);
   const [gVANVACalculation, setGVANVACalculation] = useState({
      gva: '',
      gvaClass: '',
      nva: '',
      nvaClass: '',
      ratioOutputInput: '',
      rejectedReason: '',
      totalInput: '',
      totalOutput: '',
      balanceSheet: '',
      profitAndLossStatement: '',
      attendanceMusterRoll: '',
      inspectionReport: '',
      others: ''

   });
   const [originalGVANVACalculation, setOriginalGVANVACalculation] = useState({
      gva: '',
      nva: '',
      ratioOutputInput: ''
   });
   const navigate = useNavigate();
   const yearRange = generateYearRange(blockInfo.surveyYear);
   const [buttonStatus, setButtonStatus] = useState('');

   let srNo = 0;


   useEffect(() => {
      blockLAllData();
      fetchBlockCData();
   }, [])

   // Function to fetch Block C data for depreciation calculation
   const fetchBlockCData = async () => {
      const newObject = {
         dsl_no: blockInfo.dslNo,
         survey_year: blockInfo.surveyYear
      };
      try {
         const response = await axios.post(`${API_URL}api/asi/blockCForm`, newObject, config);
         const { data, status } = response.data;
         if (status && data.blockCData) {
            setBlockCData(data.blockCData);
         }
      } catch (error) {
         console.error('Error fetching Block C data:', error);
         // Don't show error toast as this is a background fetch
      }
   };

   // Function to handle page load Form data
   const blockLAllData = async () => {
      showAppLoading(true);
      const newObject = {
         dsl_no: blockInfo.dslNo,
         survey_year: blockInfo.surveyYear
      };

      try {
         const response = await axios.post(`${API_URL}api/asi/blockLForm`, newObject, config);
         const { data, status } = response.data;
         if (status) {
            const responseBlockLData = data.blockKData;
            setBlockLData(responseBlockLData)
            data.GVANVACalculation.gvaClass = "textBox_back_color_White"
            data.GVANVACalculation.nvaClass = "textBox_back_color_White"

            // Extract file names from API response paths and convert to API_URL format
            const extractFileName = (filePath) => {
               if (!filePath || filePath === '') return '';
               // Extract filename from path (e.g., "http://192.0.0.38:8013/uploads/balanceSheet-1764241628276-717987786.pdf" -> "balanceSheet-1764241628276-717987786.pdf")
               const fileName = filePath.split('/').pop() || filePath.split('\\').pop();
               return fileName ? `${API_URL}uploads/${fileName}` : '';
            };

            // Map file paths from GVANVACalculation object
            const updatedGVANVACalculation = {
               ...data.GVANVACalculation,
               balanceSheet: extractFileName(data.GVANVACalculation.balanceSheet || ''),
               profitAndLossStatement: extractFileName(data.GVANVACalculation.profitAndLossStatement || ''),
               attendanceMusterRoll: extractFileName(data.GVANVACalculation.attendanceMusterRoll || ''),
               inspectionReport: extractFileName(data.GVANVACalculation.inspectionReport || ''),
               others: extractFileName(data.GVANVACalculation.others || '')
            };

            setGVANVACalculation(updatedGVANVACalculation);
            setOriginalGVANVACalculation(data.GVANVACalculation);
            setstatusFlageval(data.blockKData[0].statusFlag);

            const statusFlage = responseBlockLData[0].statusFlag;
            const IsButtonStatus = await validateButtonASIBlock(decode_token, statusFlage);
            const initialData = {};
            responseBlockLData.forEach(item => {
               initialData[item.ecIndicatorCode] = {
                  dslNo: item.dslNo,
                  surveyYear: item.surveyYear,
                  ecIndicatorCode: item.ecIndicatorCode,
                  code: item.code,
                  gva: item.gva,
                  nva: item.nva,
                  gvaClass: "textBox_back_color_White",
                  nvaClass: "textBox_back_color_White"
               };
            });

            setItemData(initialData);
            setButtonStatus(IsButtonStatus)
         }
      } catch (error) {
         console.error(error);
         toast.error('An error occurred while processing your request.', messages.COLOR_RED);
      } finally {
         showAppLoading(false);
      }

   }

   // Function to handle State on change
   const handleOnChange = (ecIndicatorCode, field, newValue) => {
      setItemData(prevItemData => {
         const updatedItemData = {
            ...prevItemData,
            [ecIndicatorCode]: {
               ...prevItemData[ecIndicatorCode],
               [field]: newValue
            }
         };
         return updatedItemData;
      });
   }



   // Function to handle reset Form Data
   const handleReset = () => {
      const initialData = {};
      blockLData.forEach(item => {
         initialData[item.ecIndicatorCode] = {
            dslNo: item.dslNo,
            surveyYear: item.surveyYear,
            ecIndicatorCode: item.ecIndicatorCode,
            code: '',
            gva: '',
            nva: ''
         };
      });
      setItemData(initialData);
      setGVANVACalculation({
         gva: '',
         gvaClass: '',
         nva: '',
         nvaClass: '',
         rejectedReason: '',
      });
   }




   // Function to handle file upload on change
   // const handleFileChange=(e)=>{
   //   const name=e.target.name;
   //   const file=e.target.files[0] || '';
   //   const maxSize = 40738120; 
   //   if (file && file.size > maxSize) {
   //     alert('File size exceeds the maximum limit (39 MB).');
   //     return false;
   // } 

   //    switch (name) {
   //      case 'balanceSheet':
   //        setBalanceSheet(file);
   //        break;
   //      case 'profitAndLossStatement':
   //        setProfitAndLossStatement(file);
   //        break;
   //      case 'attendanceMusterRoll':
   //        setAttendanceMusterRoll(file);
   //        break;
   //      case 'inspectionReport':
   //        setInspectionReport(file);
   //        break;
   //      case 'others':
   //        setOthers(file);
   //        break;
   //      default:
   //        alert('Invalid file type');
   //        break;
   //    }




   // }

   const handleFileChange = (e) => {
      const name = e.target.name;
      const file = e.target.files[0] || '';

      // ====== PDF ONLY VALIDATION ======
      if (file && file.type !== "application/pdf") {
         alert("Only PDF files are allowed.");
         e.target.value = "";
         return;
      }

      // ====== MAX SIZE 5 MB VALIDATION ======
      const maxSize = 5 * 1024 * 1024; // 5 MB
      if (file && file.size > maxSize) {
         alert("File size should be up to 5 MB.");
         e.target.value = "";
         return;
      }

      // ====== IF VALID → SAVE TO STATE ======
      switch (name) {
         case "balanceSheet":
            setBalanceSheet(file);
            break;
         case "profitAndLossStatement":
            setProfitAndLossStatement(file);
            break;
         case "attendanceMusterRoll":
            setAttendanceMusterRoll(file);
            break;
         case "inspectionReport":
            setInspectionReport(file);
            break;
         case "others":
            setOthers(file);
            break;
         default:
            alert("Invalid file type");
            break;
      }
   };


   // Function to handle going to the previous block
   const handlePrevious = () => {
      const confirmed = window.confirm("Have you saved your changes?");
      const shouldSkipValidation = ['4', '5', '7', '8'].includes(statusUnitCodeTrim) && blockInfo.surveyYear == '2024';
      if (confirmed) {
         if (shouldSkipValidation) {
            navigate("/BlockB")
         } else {
            navigate("/BlockK")
         }
      }
   }


   //All block validation Data
   const blockValidation = async () => {

      let postData = {
         dsl_no: blockInfo.dslNo,
         survey_year: blockInfo.surveyYear,
         statusUnitCode: statusUnitCode
      }

      try {
         showAppLoading(true);
         const response = await axios.post(`${API_URL}api/asi/blockValidation`, postData, config);
         const { data, status } = response.data;
         const accessIds = data.allblockData
         if (accessIds.length > 0) {
            const shouldSkipValidation = ['4', '5', '7', '8'].includes(statusUnitCodeTrim) && blockInfo.surveyYear == '2024';
            if (accessIds.length > [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13].length) {
               accessAsiBlock(accessIds)
            } else if (shouldSkipValidation) {
               accessAsiBlock(accessIds)
            } else {
               accessAsiBlock([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13])
            }
         } else {
            accessAsiBlock([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13])
         }
         showAppLoading(false);
         return true;

      } catch (error) {
         console.error(error);
         toast.error('An error occurred while processing your request.', messages.COLOR_RED);
      } finally {

      }

   }






   // Function to handle update and save form data
   const handleSaveData = async (buttonType) => {
      if (buttonType === 'REJECT') {
         if (gVANVACalculation.rejectedReason.length === 0) {
            toast.error(`Please fill reason for rejection`, messages.COLOR_RED);
            return false;
         } else if (gVANVACalculation.rejectedReason.length > 500) {
            toast.error(`Character limit exceeded`, messages.COLOR_RED);
            return false;
         }
      }

      // Block A code 1: Balance Sheet mandatory (non-reject)
      if (buttonType !== 'REJECT' && isBlockAStatusUnitCodeOne) {
         const hasNewBalanceSheet = Boolean(balanceSheet);
         const hasExistingBalanceSheet =
            gVANVACalculation.balanceSheet &&
            String(gVANVACalculation.balanceSheet).trim() !== '';
         if (!hasNewBalanceSheet && !hasExistingBalanceSheet) {
            toast.error('Please Upload Balance Sheet', messages.COLOR_RED);
            return false;
         }
      }
      // Block A codes 4,5,7,8: Inspection Report mandatory (non-reject)
      if (buttonType !== 'REJECT' && isBlockAInspectionReportMandatory) {
         const hasNewInspection = Boolean(inspectionReport);
         const hasExistingInspection =
            gVANVACalculation.inspectionReport &&
            String(gVANVACalculation.inspectionReport).trim() !== '';
         if (!hasNewInspection && !hasExistingInspection) {
            toast.error('Please Upload Inspection Report', messages.COLOR_RED);
            return false;
         }
      }

      console.log("statusUnitCode", gVANVACalculation.inspectionReport);
      // console.log("blockInfo.surveyYear",blockInfo.surveyYear);
      const shouldSkipValidation = ['4', '5', '7', '8'].includes(statusUnitCodeTrim) && blockInfo.surveyYear == '2024';


      if (!shouldSkipValidation && statusUnitCodeTrim !== '5' && buttonType !== 'REJECT' && !valForBlockL()) {
         return false;
      } else {

         let customItemCodes = [];
         const clickButtonStatusFlag = getStatusFlagValue(buttonType, userInfoObject.userLevel);

         for (let ecIndicatorCode in itemData) {
            const customObject = {
               dslNo: itemData[ecIndicatorCode].dslNo,
               surveyYear: itemData[ecIndicatorCode].surveyYear,
               code: itemData[ecIndicatorCode].code,
               ecIndicatorCode: itemData[ecIndicatorCode].ecIndicatorCode,
               gva: gVANVACalculation.gva,
               nva: gVANVACalculation.nva,
               totalInput: gVANVACalculation.totalInput,
               totalOutput: gVANVACalculation.totalOutput,
               rejectedReason: gVANVACalculation.rejectedReason,
               ratioOutputInput: gVANVACalculation.ratioOutputInput,
               statusFlag: clickButtonStatusFlag,
            };
            customItemCodes.push(customObject);
         }

         const newObject = {
            itemCodes: customItemCodes,
            payload: {
               dsl_no: blockInfo.dslNo,
               survey_year: blockInfo.surveyYear,
               buttonType: buttonType,
               statusFlag: clickButtonStatusFlag
            }
         }

         const formData = new FormData();
         const newObjectString = JSON.stringify(newObject);
         formData.append('BlockLData', newObjectString);

         const appendIfFile = (key, value) => {
            if (value instanceof File) {
               formData.append(key, value, value.name);
            }
         };
         appendIfFile('balanceSheet', balanceSheet);
         appendIfFile('profitAndLossStatement', profitAndLossStatement);
         appendIfFile('attendanceMusterRoll', attendanceMusterRoll);
         appendIfFile('inspectionReport', inspectionReport);
         appendIfFile('others', others);

         const formDataConfig = {
            headers: {
               Authorization: config?.headers?.Authorization,
            },
         };

         showAppLoading(true);
         try {
            const response = await axios.post(`${API_URL}api/asi/blockLFormSaveToDB`, formData, formDataConfig);
            const { status, message } = response.data;
            if (status) {
               blockValidation()
               toast.success(message, messages.COLOR_RED);
               return true;
            }
         } catch (error) {
            console.error(error);
            toast.error('An error occurred while processing your request.', messages.COLOR_RED);
         } finally {
            showAppLoading(false);
         }

         return false;


      }
   }


   // Function to handle validate the data on Save button click
   const valForBlockL = () => {


      let gvay = originalGVANVACalculation.gva;
      let nvay = originalGVANVACalculation.nva;
      let dvalue = "0.00";
      let ratioIO = originalGVANVACalculation.ratioOutputInput;


      let calculationObjectData = gVANVACalculation;

      alert(`Enter GVA Value = ${calculationObjectData.gva} && Calculated GVA Value from Forms = ${gvay}`);


      if (calculationObjectData.gva === "") {
         calculationObjectData.gvaClass = "textBox_back_color_red";
         setObjectData(calculationObjectData);
         toast.error(`Please Enter GVA`, messages.COLOR_RED);
         return false;
      }

      if (calculationObjectData.nva === "") {
         calculationObjectData.nvaClass = "textBox_back_color_red";
         setObjectData(calculationObjectData);
         toast.error(`Please Enter NVA`, messages.COLOR_RED);
         return false;
      }

      if (parseFloat(gvay) !== parseFloat(calculationObjectData.gva)) {
         calculationObjectData.gvaClass = "textBox_back_color_red";
         alert(`Entered GVA value is not matching with calculated GVA Value..?`);
         setObjectData(calculationObjectData);
         return false;
      } else {
         // If GVA values match, remove validation error
         calculationObjectData.gvaClass = "textBox_back_color_white";
         setObjectData(calculationObjectData);
      }

      // Validation: NVA = GVA - depreciation
      // Depreciation = Block C, S.No. 13 (index 12), Col. 9 (providedDuringYear)
      let depreciation = 0;
      if (blockCData && blockCData.length > 12) {
         // S.No. 13 means index 12 (0-based indexing)
         const row13 = blockCData[12];
         if (row13 && row13.providedDuringYear !== undefined && row13.providedDuringYear !== null && row13.providedDuringYear !== '') {
            depreciation = parseFloat(row13.providedDuringYear) || 0;
         }
      }

      const gvaValue = parseFloat(calculationObjectData.gva) || 0;
      const nvaValue = parseFloat(calculationObjectData.nva) || 0;
      const expectedNVA = gvaValue - depreciation;
      const tolerance = 0.01; // Allow small difference for rounding errors

      // Check if depreciation value is available
      if (blockCData && blockCData.length > 12) {
         const row13 = blockCData[12];
         if (row13 && row13.providedDuringYear !== undefined && row13.providedDuringYear !== null && row13.providedDuringYear !== '') {
            // Depreciation value found, validate NVA
            // Single alert message for NVA: "Enter NVA Value = X && Calculated NVA Value From Form = (GVA - Depreciation) = Y"
            alert(`Enter NVA Value = ${nvaValue} && Calculated NVA Value From Form = (GVA - Depreciation) = ${expectedNVA.toFixed(2)}`);

            if (Math.abs(nvaValue - expectedNVA) > tolerance) {
               calculationObjectData.nvaClass = "textBox_back_color_red";
               setObjectData(calculationObjectData);
               return false;
            } else {
               calculationObjectData.nvaClass = "textBox_back_color_white";
            }
         } else {
            // Depreciation value not found in Block C
            calculationObjectData.nvaClass = "textBox_back_color_red";
            alert(`Depreciation value not found in Block C (S.No. 13, Col. 9). Please ensure Block C data is saved.`);
            setObjectData(calculationObjectData);
            return false;
         }
      } else {
         // Block C data not available
         calculationObjectData.nvaClass = "textBox_back_color_red";
         alert(`Block C data not available. Please ensure Block C data is saved.`);
         setObjectData(calculationObjectData);
         return false;
      }

      if (parseFloat(calculationObjectData.gva) < 0) {
         alert(`Entered GVA is negative!`);
         setObjectData(calculationObjectData);
         //return false;
      }

      if (parseFloat(nvay) < 0) {
         setObjectData(calculationObjectData);
         alert(`Calculated NVA is negtive!`);
         //return false;
      }

      if (parseFloat(calculationObjectData.nva) < 0) {
         setObjectData(calculationObjectData)
         alert(`Entered NVA is negtive!`);
         //return false;       
      }

      if (parseFloat(ratioIO) > 10) {
         const flag = window.confirm(`Ratio should not be greater than 10 = ${ratioIO} && Do you want to change?`);
         if (flag) {
            return false;
         }

      }
      return true
   }


   const setObjectData = (calculationObjectData) => {
      setGVANVACalculation({
         ...calculationObjectData,
         calculationObjectData
      });
      return true;

   }

   const handleValue = (value) => {
      return (value !== "" && value !== null && value !== undefined) ? value : 0;
   };



   // Function to handle form field changes
   const handleInputGVANVAChange = (e) => {
      const { name, value } = e.target;

      // Auto-calculate NVA when GVA changes: NVA = GVA - depreciation
      if (name === 'gva') {
         // Get depreciation from Block C, row 13 (index 12), column 9 (providedDuringYear)
         let depreciation = 0;
         if (blockCData && blockCData.length > 12) {
            const row13 = blockCData[12];
            if (row13 && row13.providedDuringYear !== undefined && row13.providedDuringYear !== null && row13.providedDuringYear !== '') {
               depreciation = parseFloat(row13.providedDuringYear) || 0;
            }
         }

         const gvaValue = parseFloat(value) || 0;
         const calculatedNVA = gvaValue - depreciation;

         // Real-time validation for GVA: compare with calculated GVA from forms
         const calculatedGVA = parseFloat(originalGVANVACalculation.gva) || 0;
         const tolerance = 0.01;

         // If GVA value matches calculated value, remove validation error
         if (value !== '' && Math.abs(gvaValue - calculatedGVA) <= tolerance) {
            setGVANVACalculation({
               ...gVANVACalculation,
               [name]: value,
               gvaClass: 'textBox_back_color_white',
               nva: calculatedNVA > 0 ? calculatedNVA.toFixed(2) : '',
               nvaClass: 'textBox_back_color_white'
            });
         } else {
            // GVA value doesn't match - show error immediately
            setGVANVACalculation({
               ...gVANVACalculation,
               [name]: value,
               gvaClass: value !== '' ? 'textBox_back_color_red' : 'textBox_back_color_white',
               nva: calculatedNVA > 0 ? calculatedNVA.toFixed(2) : '',
               nvaClass: 'textBox_back_color_white'
            });
         }
      } else if (name === 'nva') {
         // When user manually changes NVA, validate it in real-time
         // Get depreciation from Block C, row 13 (index 12), column 9 (providedDuringYear)
         let depreciation = 0;
         if (blockCData && blockCData.length > 12) {
            const row13 = blockCData[12];
            if (row13 && row13.providedDuringYear !== undefined && row13.providedDuringYear !== null && row13.providedDuringYear !== '') {
               depreciation = parseFloat(row13.providedDuringYear) || 0;
            }
         }

         const gvaValue = parseFloat(gVANVACalculation.gva) || 0;
         const nvaValue = parseFloat(value) || 0;
         const expectedNVA = gvaValue - depreciation;
         const tolerance = 0.01;

         // If value doesn't match, highlight in red, otherwise white
         if (value !== '' && Math.abs(nvaValue - expectedNVA) > tolerance) {
            setGVANVACalculation({
               ...gVANVACalculation,
               [name]: value,
               nvaClass: 'textBox_back_color_red'
            });
         } else {
            setGVANVACalculation({
               ...gVANVACalculation,
               [name]: value,
               nvaClass: 'textBox_back_color_white'
            });
         }
      } else {
         setGVANVACalculation({
            ...gVANVACalculation,
            [name]: value
         });
      }
   };


   const downloadFile = (filePath, fileName) => {
      // debugger;
      if (fileName && filePath) {
         const link = document.createElement('a');
         link.href = filePath;
         // link.download = fileName; 
         link.target = "_blank";
         document.body.appendChild(link);
         link.click();
         document.body.removeChild(link);
      } else {
         alert("Please Upload the file");
      }


   }


   const userLevel = decode_token.id.USER_TYPE;
   const roles = decode_token.id.ROLE_CODE
      ? decode_token.id.ROLE_CODE.split('|').map((r) => String(r).trim())
      : [];
   const isDivasiRole = roles.includes('DIVASI');
   const isDivasiStatusFlagOne = isDivasiRole && String(statusFlageval ?? '').trim() === '1';
   const isHqRole = roles.includes('HQADM') || roles.includes('HQASI');
   const isHqStatusFlagThree = isHqRole && String(statusFlageval ?? '').trim() === '3';
   const isRestrictedRoleWithEmptyStatusFlag = (isDivasiRole || isHqRole) && String(statusFlageval ?? '').trim() === '';
   const isNextBlockAlreadyAccessible = (() => {
      const ids = JSON.parse(localStorage.getItem('blockIds') || '[]');
      return Array.isArray(ids) && ids.map(Number).includes(13);
   })();
   const isFACTO = roles.includes('FACTO');
   const isFactoFactoryUser = userLevel === 'FACTORY LEVEL' && isFACTO;

   // Use useEffect to set button disabled states after DOM is rendered
   useEffect(() => {
      let duser = 0;
      if (userLevel === 'DIVISION LEVEL') {
         if (statusFlageval === "3" || statusFlageval === "7" || statusFlageval === "8")
            duser = 1;
      }
      if (statusFlageval === "4" || statusFlageval === "9") {
         const rejectBtn = document.getElementById("reject");
         if (rejectBtn) {
            rejectBtn.disabled = true;
         }
      }
      if (userLevel === 'HEAD QUARTER') {
         // "8" hata: HQ Accept Block L par validate ke mutabiq enable rahe
         if (statusFlageval === "2" || statusFlageval === "6") {
            duser = 1;
         }
         if (statusFlageval == "3") {
            duser = 2;
         }
      }
      if (duser === 2) {
         if (userLevel === 'HEAD QUARTER') {
            // Status 3: HQADM/HQASI ko Save validateButtonASIBlock se enabled — DOM se band mat karo
            if (!(statusFlageval === "3" && isHqAsiAdminRole(roles))) {
               const saveBtn = document.getElementById("save");
               if (saveBtn) {
                  saveBtn.disabled = true;
               }
            }
         }
      }
      if (duser === 1) {
         const saveBtn = document.getElementById("save");
         if (saveBtn) {
            saveBtn.disabled = true;
         }
         if (userLevel === 'DIVISION LEVEL') {
            const submitBtn = document.getElementById("submit");
            if (submitBtn) {
               submitBtn.disabled = true;
            }
            const rejectBtnDiv = document.getElementById("reject");
            if (rejectBtnDiv) {
               rejectBtnDiv.disabled = true;
            }
         }
         if (userLevel === 'HEAD QUARTER') {
            const acceptBtn = document.getElementById("accept");
            const rejectBtn = document.getElementById("reject");
            if (acceptBtn) {
               acceptBtn.disabled = true;
            }
            if (rejectBtn) {
               rejectBtn.disabled = true;
            }
         }
      }
   }, [userLevel, statusFlageval]);


   // Function to handle going to the next block
   const handleNext = async () => {
         // Next unlocked + Save disabled → skip save, sirf navigate (DIVASI/FACTO/DISASI/HQ sab)
         if (isNextBlockAlreadyAccessible && (buttonStatus || isDivasiStatusFlagOne || isHqStatusFlagThree || isRestrictedRoleWithEmptyStatusFlag)) {
            navigate("/BlockM");
            return;
         }
         // DIVASI + statusFlag=1: do not save, just navigate
         if (isDivasiStatusFlagOne) {
            navigate("/BlockM");
            return;
         }
         // HQADM/HQASI + statusFlag=3: do not save, just navigate
         if (isHqStatusFlagThree) {
            navigate("/BlockM");
            return;
         }
         const confirmed = window.confirm("Have you saved your changes?");
         if (!confirmed) return;
         if (statusUnitCode === '5') {

            const saveResult = await handleSaveData("SAVE");
            if (saveResult) {
               await blockValidation()
               navigate("/BlockM")
            }

         } else {
            const saveResult = await handleSaveData("SAVE");
            if (saveResult) {
               await blockValidation()
               navigate("/BlockM");
            }
         }
   }





   const formatDateTime = (value) => {
      if (!value) return '-';
      try {
         return new Date(value).toLocaleString();
      } catch (error) {
         return value;
      }
   };

   const handleRejectedReasonLog = async () => {
      setRejectLog([]);
      setRejectLogError('');
      setIsRejectLogFetching(true);
      showAppLoading(true);
      try {
         const payload = {
            dsl_no: blockInfo.dslNo,
            survey_year: blockInfo.surveyYear
         };
         const response = await axios.post(`${API_URL}api/asi/blockL/rejectLog`, payload, config);
         const { status, data, message } = response.data || {};
         if (status && Array.isArray(data) && data.length > 0) {
            const mappedData = data.map((entry, index) => ({
               id: `${entry.dateTime || index}-${index}`,
               level: entry.level || '-',
               reason: entry.reason || '-',
               action: entry.action || '-',
               dateTime: formatDateTime(entry.dateTime)
            }));
            setRejectLog(mappedData);
         } else {
            setRejectLog([]);
            setRejectLogError(message || 'No rejected reason log found.');
         }
      } catch (error) {
         console.error('Error fetching rejected reason log:', error);
         const apiMessage = error.response?.data?.message || error.message || 'Unable to fetch rejected reason log.';
         setRejectLogError(apiMessage);
      } finally {
         setIsRejectLogFetching(false);
         setShowRejectLogModal(true);
         showAppLoading(false);
      }
   }

   const closeRejectedReasonModal = () => {
      setShowRejectLogModal(false);
   }

   useEffect(() => {
      if (showRejectLogModal) {
         bodyOverflowRef.current = document.body.style.overflow;
         document.body.style.overflow = 'hidden';
      } else if (bodyOverflowRef.current !== undefined) {
         document.body.style.overflow = bodyOverflowRef.current || '';
      }
      return () => {
         document.body.style.overflow = bodyOverflowRef.current || '';
      };
   }, [showRejectLogModal]);

   const modalOverlayStyle = {
      display: 'block',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 1050,
      pointerEvents: 'auto',
      willChange: 'auto',
      transition: 'none'
   };

   const modalDialogStyle = {
      position: 'relative',
      width: 'auto',
      margin: '1.75rem auto',
      pointerEvents: 'none',
      zIndex: 1051,
      willChange: 'auto',
      transform: 'none',
      transition: 'none'
   };

   const modalContentStyle = {
      maxHeight: '70vh',
      overflowY: 'auto',
      position: 'relative',
      pointerEvents: 'auto',
      border: '1px solid rgba(0, 0, 0, 0.2)',
      borderRadius: '0.5rem',
      boxShadow: '0 0.5rem 1rem rgba(0, 0, 0, 0.15)',
      backgroundColor: '#fff',
      willChange: 'auto',
      transform: 'none',
      transition: 'none'
   };

   const storedLanguage = localStorage.getItem('language');



   //   const handleFileChange = (e) => {
   //    const file = e.target.files[0];
   //    const name = e.target.name;

   //    if (!file) return;

   //    // Allowed file type check (PDF only)
   //    if (file.type !== "application/pdf") {
   //      alert("Only PDF files are allowed.");
   //      e.target.value = "";
   //      return;
   //    }

   //    // File size check — max 5 MB
   //    const maxSize = 5 * 1024 * 1024; // 5 MB in bytes
   //    if (file.size > maxSize) {
   //      alert("File size must be less than or equal to 5 MB.");
   //      e.target.value = "";
   //      return;
   //    }

   //    // If validation is passed
   //    setGVANVACalculation((prev) => ({
   //      ...prev,
   //      [name]: file
   //    }));
   //  };


   return (
      <>
         <div className="card-body">
            <h4 className="page_heading border-bottom-0">
               <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? asiTitle.hi.BLOCK_L_TITLE : asiTitle.en.BLOCK_L_TITLE }} />
            </h4>

            <div className="row">
               <div className="col-12">
                  <h6 className="fw-semibold">
                     {storedLanguage === 'hi' ? asiTitle.hi.DSL_NO : asiTitle.en.DSL_NO}: <span className="fw-normal me-5">{blockInfo.dslNo}</span>
                     {storedLanguage === 'hi' ? asiTitle.hi.SERVEY_YEAR : asiTitle.en.SERVEY_YEAR}: <span className="fw-normal">{yearRange}</span>
                  </h6>
                  <div className="table-responsive asi_block_table">
                     <table cellPadding="0" cellSpacing="0" id="" className="table table-bordered block_c_table">
                        <thead>
                           <tr style={{ textAlign: 'center' }}>
                              <th>{storedLanguage === 'hi' ? asiTitle.hi.SL_NO : asiTitle.en.SL_NO}</th>
                              <th colSpan="2">{storedLanguage === 'hi' ? asiTitle.hi.EC_INDICATOR : asiTitle.en.EC_INDICATOR}</th>
                              <th><div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? asiTitle.hi.CODE : asiTitle.en.CODE }} /></th>
                           </tr>
                           <tr>
                              <th colSpan="2">{storedLanguage === 'hi' ? asiTitle.hi.BLOCK_L_MEASURE_TAKEN : asiTitle.en.BLOCK_L_MEASURE_TAKEN}</th>
                              <th colSpan="2">&nbsp;</th>
                           </tr>
                        </thead>
                        <tbody>
                           {blockLData.length > 0 && blockLData.map((item, i) => {

                              return (
                                 <tr key={i}>
                                    <td style={{ textAlign: 'center' }}> {++i}
                                    </td>
                                    <td colSpan="2">
                                       {item.ItemsName}
                                    </td>
                                    <td>
                                       <select
                                          className="form-select"
                                          id={`code${i}`}
                                          name={`code${i}`}
                                          value={itemData[item.ecIndicatorCode].code}
                                          onChange={e => handleOnChange(item.ecIndicatorCode, 'code', e.target.value)}
                                       >
                                          <option value="">Select</option>
                                          <option value="1">1</option>
                                          <option value="2">2</option>
                                       </select>
                                    </td>
                                 </tr>
                              )
                           })}

                           {/* Show Rejected Reason for years 2022-23, 2023-24 (surveyYear < 2024) */}
                           {(() => {
                              const surveyYearNum = typeof blockInfo.surveyYear === 'string' 
                                 ? parseInt(blockInfo.surveyYear.split('-')[0]) 
                                 : parseInt(blockInfo.surveyYear);
                              return surveyYearNum < 2024 && !isFACTO;
                           })() && (
                              <>
                                 <tr>
                                    <td colSpan="4" className="bg-light text-center fw-bold">
                                       <h5>Rejected Reason</h5>
                                    </td>
                                 </tr>
                                 <tr>
                                    <td colSpan="4">
                                       <textarea
                                          cols="100"
                                          rows="2"
                                          className="form-control h-auto"
                                          name="rejectedReason"
                                          id="rejectedReason"
                                          value={gVANVACalculation.rejectedReason}
                                          onChange={(e) => (handleInputGVANVAChange(e))}
                                       >
                                       </textarea>
                                    </td>
                                 </tr>
                              </>
                           )}
                           <tr>
                              <td colSpan="4" className="bg-light text-center fw-bold">
                                 <h5>GVA-NVA Calculation</h5>
                              </td>
                           </tr>
                           <tr>
                              <td className="text-end fw-bold">GVA</td>
                              <td className={gVANVACalculation.gvaClass}>
                                 <input
                                    type="text"
                                    className="form-control"
                                    id={`gva`}
                                    name={`gva`}
                                    maxLength="18"
                                    value={gVANVACalculation.gva}
                                    onChange={(e) => (handleInputGVANVAChange(e))}
                                 />
                              </td>
                              <td className="text-end fw-bold">Total Input</td>
                              <td>
                                 <input
                                    type="text"
                                    disabled="disabled"
                                    className="form-control"
                                    id={`totalInput`}
                                    name={`totalInput`}
                                    maxLength="18"
                                    value={gVANVACalculation.totalInput}
                                 />
                              </td>
                           </tr>
                           <tr>
                              <td className="text-end fw-bold">NVA</td>
                              <td className={gVANVACalculation.nvaClass}>
                                 <input
                                    type="text"
                                    className="form-control"
                                    id={`nva`}
                                    name={`nva`}
                                    maxLength="18"
                                    value={gVANVACalculation.nva}
                                    onChange={(e) => (handleInputGVANVAChange(e))}
                                 />
                              </td>
                              <td className="text-end fw-bold">Total Output</td>
                              <td>
                                 <input
                                    type="text"
                                    disabled="disabled"
                                    className="form-control"
                                    id={`totalOutput`}
                                    name={`totalOutput`}
                                    maxLength="18"
                                    value={gVANVACalculation.totalOutput}
                                    style={{ padding: '3px 0px 3px 3px' }}
                                 />
                              </td>
                           </tr>
                           <tr>
                              <td align="center" colSpan="4" className="fw-bold"><b>Ratio (Output/Input): <input
                                 type="text"
                                 id={`ratioIO`}
                                 name={`ratioIO`}
                                 maxLength="5"
                                 value={gVANVACalculation.ratioOutputInput}
                                 disabled="disabled"
                              /></b></td>
                           </tr>
                           <tr>
                              <td colSpan="4">
                                 <div className="row g-2" style={{ width: '100%', margin: '0' }}>
                                    <div className="col" style={{ flex: '1 1 0', minWidth: '0' }}>
                                       <label className="mb-2">
                                          Upload Balance Sheet
                                          {isBlockAStatusUnitCodeOne && (
                                             <span className="text-danger" title="Required when Status of Unit code is 1">
                                                {' '}
                                                *
                                             </span>
                                          )}
                                       </label>
                                       <input
                                          type="file"
                                          className="form-control mb-2"
                                          name="balanceSheet"
                                          id="balanceSheet"
                                          accept="application/pdf"
                                          onChange={(e) => (handleFileChange(e))}
                                       />
                                       {gVANVACalculation.balanceSheet && (
                                          <div className="mb-2" style={{ wordBreak: 'break-word', whiteSpace: 'normal', lineHeight: '1.3', fontSize: '12px' }}>
                                             <small className="text-muted d-block">Current file: <span style={{ wordBreak: 'break-all', display: 'inline-block' }}>{gVANVACalculation.balanceSheet.split('/').pop()}</span></small>
                                          </div>
                                       )}
                                       <button
                                          className="btn btn-sm btn-success"
                                          type="button"
                                          onClick={() => (downloadFile(gVANVACalculation.balanceSheet, 'balance_sheet'))}
                                          disabled={!gVANVACalculation.balanceSheet}
                                       >
                                          Download
                                       </button>
                                    </div>
                                    <div className="col" style={{ flex: '1 1 0', minWidth: '0' }}>
                                       <label className="mb-2">Upload Profit and Loss Statement</label>
                                       <input
                                          type="file"
                                          className="form-control mb-2"
                                          name="profitAndLossStatement"
                                          id="profitAndLossStatement"
                                          accept="application/pdf"
                                          onChange={(e) => (handleFileChange(e))}
                                       />
                                       {gVANVACalculation.profitAndLossStatement && (
                                          <div className="mb-2" style={{ wordBreak: 'break-word', whiteSpace: 'normal', lineHeight: '1.3', fontSize: '12px' }}>
                                             <small className="text-muted d-block">Current file: <span style={{ wordBreak: 'break-all', display: 'inline-block' }}>{gVANVACalculation.profitAndLossStatement.split('/').pop()}</span></small>
                                          </div>
                                       )}
                                       <button
                                          className="btn btn-sm btn-success"
                                          type="button"
                                          onClick={() => (downloadFile(gVANVACalculation.profitAndLossStatement, 'profit_and_loss_statement'))}
                                          disabled={!gVANVACalculation.profitAndLossStatement}
                                       >
                                          Download
                                       </button>
                                    </div>
                                    <div className="col" style={{ flex: '1 1 0', minWidth: '0' }}>
                                       <label className="mb-2">Upload Attendance Master Roll</label>
                                       <input
                                          type="file"
                                          className="form-control mb-2"
                                          name="attendanceMusterRoll"
                                          id="attendanceMusterRoll"
                                          accept="application/pdf"
                                          onChange={(e) => (handleFileChange(e))}
                                       />
                                       {gVANVACalculation.attendanceMusterRoll && (
                                          <div className="mb-2" style={{ wordBreak: 'break-word', whiteSpace: 'normal', lineHeight: '1.3', fontSize: '12px' }}>
                                             <small className="text-muted d-block">Current file: <span style={{ wordBreak: 'break-all', display: 'inline-block' }}>{gVANVACalculation.attendanceMusterRoll.split('/').pop()}</span></small>
                                          </div>
                                       )}
                                       <button
                                          className="btn btn-sm btn-success"
                                          type="button"
                                          onClick={() => (downloadFile(gVANVACalculation.attendanceMusterRoll, 'attendance_muster_roll'))}
                                          disabled={!gVANVACalculation.attendanceMusterRoll}
                                       >
                                          Download
                                       </button>
                                    </div>
                                    <div className="col" style={{ flex: '1 1 0', minWidth: '0' }}>
                                       <label className="mb-2">
                                          Upload Inspection Report
                                          {isBlockAInspectionReportMandatory && (
                                             <span className="text-danger" title="Required when Status of Unit code is 4, 5, 7 or 8">
                                                {' '}
                                                *
                                             </span>
                                          )}
                                       </label>
                                       <input
                                          type="file"
                                          className="form-control mb-2"
                                          name="inspectionReport"
                                          id="inspectionReport"
                                          accept="application/pdf"
                                          onChange={(e) => (handleFileChange(e))}
                                       />
                                       {gVANVACalculation.inspectionReport && (
                                          <div className="mb-2" style={{ wordBreak: 'break-word', whiteSpace: 'normal', lineHeight: '1.3', fontSize: '12px' }}>
                                             <small className="text-muted d-block">Current file: <span style={{ wordBreak: 'break-all', display: 'inline-block' }}>{gVANVACalculation.inspectionReport.split('/').pop()}</span></small>
                                          </div>
                                       )}
                                       <button
                                          className="btn btn-sm btn-success"
                                          type="button"
                                          onClick={() => (downloadFile(gVANVACalculation.inspectionReport, 'inspection_report'))}
                                          disabled={!gVANVACalculation.inspectionReport}
                                       >
                                          Download
                                       </button>
                                    </div>
                                    <div className="col" style={{ flex: '1 1 0', minWidth: '0' }}>
                                       <label className="mb-2">Upload Others</label>
                                       <input
                                          type="file"
                                          className="form-control mb-2"
                                          name="others"
                                          id="others"
                                          accept="application/pdf"
                                          onChange={(e) => (handleFileChange(e))}
                                       />
                                       {gVANVACalculation.others && (
                                          <div className="mb-2" style={{ wordBreak: 'break-word', whiteSpace: 'normal', lineHeight: '1.3', fontSize: '12px' }}>
                                             <small className="text-muted d-block">Current file: <span style={{ wordBreak: 'break-all', display: 'inline-block' }}>{gVANVACalculation.others.split('/').pop()}</span></small>
                                          </div>
                                       )}
                                       <button
                                          className="btn btn-sm btn-success"
                                          type="button"
                                          onClick={() => (downloadFile(gVANVACalculation.others, 'others'))}
                                          disabled={!gVANVACalculation.others}
                                       >
                                          Download
                                       </button>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
               </div>
            </div>
            <div className="row">
               <div className="col-12">
                  <hr />
               </div>
               <div className="col-lg-8 text-center text-lg-start mb-3 mb-lg-0">
                  <button
                     type="submit"
                     className="btn btn_orange mx-1"
                     onClick={() => (window.print())}
                  >Print
                     <i className="fa fa-print ms-1"></i>
                  </button>
                  <button
                     type="button"
                     className="btn btn_orange mx-1"
                     onClick={(e) => handleSaveData('SAVE')}
                     disabled={buttonStatus || isDivasiStatusFlagOne || isHqStatusFlagThree || isRestrictedRoleWithEmptyStatusFlag}
                     id="save"
                  >
                     Save
                  </button>

                  {/* Show buttons for years 2022-23, 2023-24 (surveyYear < 2024) */}
                  {(() => {
                     const surveyYearNum = typeof blockInfo.surveyYear === 'string' 
                        ? parseInt(blockInfo.surveyYear.split('-')[0]) 
                        : parseInt(blockInfo.surveyYear);
                     return surveyYearNum < 2024;
                  })() && (
                     <>
                        {(decode_token.id.USER_TYPE === 'DIVISION LEVEL') &&
                           <>
                              <button type="button" className={`btn btn_orange mx-1`}
                                 onClick={(e) => { handleSaveData("SUBMIT") }} id="submit"
                                 disabled={buttonStatus}
                              >
                                 Submit
                              </button>
                           </>
                        }

                        {(decode_token.id.USER_TYPE === 'HEAD QUARTER') &&
                           <>
                              <button type="button" className={`btn btn_orange mx-1`}
                                 onClick={(e) => { handleSaveData("ACCEPT") }} id="accept"
                                 disabled={buttonStatus}
                              >
                                 Accept
                              </button>
                           </>
                        }

                        {(decode_token.id.USER_TYPE === 'DISTRICT LEVEL' || decode_token.id.USER_TYPE === 'HEAD QUARTER' || decode_token.id.USER_TYPE === 'DIVISION LEVEL') &&
                           <>
                              <button type="button" className={`btn btn_orange mx-1`} id="reject"
                                 onClick={(e) => { handleSaveData("REJECT") }}
                                 disabled={buttonStatus}
                              >
                                 Reject
                              </button>
                           </>
                        }

                        <button
                           type="button"
                           className="btn btn_orange mx-1"
                           onClick={handleRejectedReasonLog}
                           disabled={isRejectLogFetching}
                        >
                           {isRejectLogFetching ? 'Loading...' : 'Rejected Reason Log'}
                        </button>
                     </>
                  )}

                  <button
                     type="reset"
                     className="btn btn_orange mx-1"
                     onClick={handleReset}
                  >
                     Reset
                  </button>

                  <button
                     type="button"
                     className="btn btn_orange"
                     onClick={(e) => (navigate("/dashboard"))}
                  >
                     Cancel
                  </button>
               </div>
               <div className="col-lg-4 text-center text-lg-end">
                  {/* <button 
                     type="button" 
                     className="btn btn_orange mx-1"
                     onClick={()=>(navigate('/BlockA'))}
                      >
                     Block A
                    </button> */}

                  <button
                     type="button"
                     className="btn btn_orange mx-1"
                     onClick={handlePrevious}
                  >
                     <i className="fa fa-angle-left me-1"></i>
                     Previous
                  </button>

                  <button
                     type="button"
                     className="btn btn_orange mx-1"
                     onClick={handleNext}
                     disabled={isNextBlockAlreadyAccessible ? false : (isRestrictedRoleWithEmptyStatusFlag ? true : ((isDivasiStatusFlagOne || isHqStatusFlagThree) ? false : buttonStatus))}
                  >
                     Next
                     <i className="fa fa-angle-right ms-1"></i>
                  </button>

               </div>
            </div>
         </div>
         {showRejectLogModal && (
            <div
               className="modal fade show"
               style={modalOverlayStyle}
               role="dialog"
               aria-modal="true"
               onClick={closeRejectedReasonModal}
            >
               <div
                  className="modal-dialog modal-lg modal-dialog-centered"
                  style={modalDialogStyle}
                  onClick={(e) => e.stopPropagation()}
               >
                  <div className="modal-content" style={modalContentStyle}>
                     <div className="modal-header">
                        <h5 className="modal-title">Rejected Reason Log</h5>
                        <button
                           type="button"
                           className="btn-close"
                           aria-label="Close"
                           onClick={closeRejectedReasonModal}
                        ></button>

                     </div>
                     <div className="modal-body">
                        {rejectLogError && (
                           <div className="alert alert-warning mb-3">
                              {rejectLogError}
                           </div>
                        )}
                        {!rejectLogError && rejectLog.length === 0 && (
                           <p className="mb-0">No rejected reason log found.</p>
                        )}
                        {rejectLog.length > 0 && (
                           <div className="table-responsive">
                              <table className="table table-bordered">
                                 <thead>
                                    <tr>
                                       <th>S.No</th>
                                       <th>Level</th>
                                       <th>Action</th>
                                       <th>Rejected Reason</th>
                                       <th>Date &amp; Time</th>
                                    </tr>
                                 </thead>
                                 <tbody>
                                    {rejectLog.map((entry, index) => (
                                       <tr key={entry.id || index}>
                                          <td>{index + 1}</td>
                                          <td>{entry.level}</td>
                                          <td>{entry.action}</td>
                                          <td>{entry.reason}</td>
                                          <td>{entry.dateTime}</td>
                                       </tr>
                                    ))}
                                 </tbody>
                              </table>
                           </div>
                        )}
                     </div>
                     <div className="modal-footer">
                        <button
                           type="button"
                           className="btn btn-secondary"
                           onClick={closeRejectedReasonModal}
                        >
                           Close
                        </button>
                     </div>
                  </div>
               </div>
            </div>
         )}
      </>
   );
}
